import React from "react";
import FooterCol from "./FooterCol";
import ParaText from "./ParaText";

export default function Footer({ children }) {
  return (
    <div className="footer__container">
      <div className="footer__wrapper">
        <div className="footers">
          <div className="footer__col1">
            <h1 className="footer__col1__title">Laolu Ajibade</h1>
            <ParaText className="aboutsection__paraText">
              A fullstack software developer and designer from Lagos, Nigeria. I
              make Website with Unique touchs and designs and focused on SEO and
              good performance rate
            </ParaText>
          </div>
          <div className="footer__col2 ">
            <FooterCol
              heading="Important Links"
              links={[
                {
                  title: "Home",
                  path: "/",
                  type: "Link",
                },
                {
                  title: "About",
                  path: "/about",
                  type: "Link",
                },
                {
                  title: "Projects",
                  path: "/projects",
                  type: "Link",
                },
                {
                  title: "Contact",
                  path: "/contact",
                  type: "Link",
                },
              ]}
            />
          </div>
          <div className="footer__col3">
            <FooterCol
              heading="Contact Info"
              links={[
                {
                  title: "+2348055966944",
                  path: "tel:+2348055966944",
                },
                {
                  title: "holaszyd1@gmail.com",
                  path: "mailto:holaszyd1@gmail.com",
                },
                {
                  title: "Africa",
                  path: "https://google.com/maps",
                },
              ]}
            />
          </div>
          <div className="footer__col4">
            <FooterCol
              heading="Social Links"
              links={[
                {
                  title: "Twitter",
                  path: "https://twitter.com/Jiblaze101",
                },
                {
                  title: "Linkedin",
                  path: "https://www.linkedin.com/in/olunowo-olaoluwa-ajibade-58516519a/",
                },
                {
                  title: "Facebook",
                  path: "https://web.facebook.com/olunowo.olaoluwa",
                },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="footer__copyright">
        <ParaText className="aboutsection__paraText">
         ©2022 Made with ❤ by @ajibadde Powered by Vercel
        </ParaText>
      </div>
    </div>
  );
}
